import React, { useState, useEffect } from 'react';
import { UserCounts } from '../types';
import { usersAPI } from '../services/api';
import LoadingSpinner from './LoadingSpinner';
import './UserStats.css';

const UserStats: React.FC = () => {
  const [userCounts, setUserCounts] = useState<UserCounts>({
    totalUsers: 0,
    activeUsers: 0,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadUserCounts();
    // Оновлюємо кожні 60 секунд
    const interval = setInterval(loadUserCounts, 60000);
    return () => clearInterval(interval);
  }, []);

  const loadUserCounts = async () => {
    try {
      const counts = await usersAPI.getCounts();
      setUserCounts(counts);
    } catch (error) {
      console.error('Failed to load user counts:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="user-stats">
        <LoadingSpinner text="Загрузка статистики пользователей..." />
      </div>
    );
  }

  return (
    <div className="user-stats">
      <h3>Статистика пользователей</h3>
      <div className="stats-grid">
        <div className="stat-item">
          <div className="stat-value">{userCounts.totalUsers}</div>
          <div className="stat-label">Всего пользователей</div>
        </div>
        <div className="stat-item">
          <div className="stat-value">{userCounts.activeUsers}</div>
          <div className="stat-label">Активных пользователей</div>
        </div>
      </div>
    </div>
  );
};

export default UserStats;
